import React from 'react'
import './styles.css';

const loading = () => (
	<div id="cover">
		<div id="load">
			<div>G</div>
			<div>N</div>
			<div>I</div>
			<div>D</div>
			<div>A</div>
			<div>O</div>
			<div>L</div>
		</div>
	</div>
);

export default loading;